import { LeadDto } from '@model/LeadDto'

import { ReferralParams, isReferralLink } from './helpers'

export type ReferralTokenValues =
  | {
      aff_token: string
      referral_code: null
      referral_main_ib_code: null
    }
  | {
      aff_token: null
      referral_code: string
      referral_main_ib_code: string | null
    }
  | {
      aff_token: null
      referral_code: null
      referral_main_ib_code: null
    }

const emptyReferralTokenValues: ReferralTokenValues = {
  aff_token: null,
  referral_code: null,
  referral_main_ib_code: null,
}

export const getReferralTokenCookieValues = (params: ReferralParams): ReferralTokenValues => {
  if (params.aff_token) {
    return {
      aff_token: params.aff_token,
      referral_code: null,
      referral_main_ib_code: null,
    }
  }

  if (params.referral_code) {
    return {
      aff_token: null,
      referral_code: params.referral_code,
      referral_main_ib_code: isReferralLink(params) ? params.referral_code : null,
    }
  }

  return emptyReferralTokenValues
}

const getReferralTokenLeadValues = (lead?: LeadDto): ReferralTokenValues => {
  if (!lead?.activities?.length) return emptyReferralTokenValues

  const activitiesWithCode = lead.activities.filter((x) => x.referralCode || x.affiliateToken)
  const latestActivityWithCode = activitiesWithCode.sort(
    (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
  )[0]

  if (!latestActivityWithCode) return emptyReferralTokenValues

  if (latestActivityWithCode.referralCode) {
    return {
      aff_token: null,
      referral_code: latestActivityWithCode.referralCode,
      referral_main_ib_code:
        latestActivityWithCode.campaign === 'ib_link' ||
        latestActivityWithCode.referralCode.toLowerCase().startsWith('ib')
          ? latestActivityWithCode.referralCode
          : null,
    }
  }

  if (latestActivityWithCode.affiliateToken) {
    return {
      aff_token: latestActivityWithCode.affiliateToken,
      referral_code: null,
      referral_main_ib_code: null,
    }
  }

  return emptyReferralTokenValues
}

const hasReferralTokenValue = (values: ReferralTokenValues): boolean => {
  return !!(values.aff_token || values.referral_code || values.referral_main_ib_code)
}

export const getReferralTokenValues = (
  params: ReferralParams,
  lead?: LeadDto
): ReferralTokenValues => {
  const leadValues = getReferralTokenLeadValues(lead)

  if (hasReferralTokenValue(leadValues)) return leadValues
  return getReferralTokenCookieValues(params)
}
